export const TYPING_DELAY_MIN_MS = 900;
export const TYPING_DELAY_MAX_MS = 4500;
export const TYPING_MS_PER_CHAR = 28;

/** Simulated human typing pause before revealing an assistant reply. */
export function computeTypingDelay(text: string): number {
  const length = String(text ?? '').length;
  return Math.min(
    TYPING_DELAY_MAX_MS,
    Math.max(TYPING_DELAY_MIN_MS, length * TYPING_MS_PER_CHAR),
  );
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/** Waits at least `delayMs` from `startedAt` (e.g. fetch start). */
export async function waitForTypingDelay(
  text: string,
  startedAt: number,
): Promise<void> {
  const delay = computeTypingDelay(text);
  const elapsed = Date.now() - startedAt;
  const remaining = delay - elapsed;
  if (remaining > 0) await sleep(remaining);
}
